/** Filters currency codes by code or name (case-insensitive, accent-insensitive); code matches rank first. */
const norm = (s: string) => s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

export function filterCurrencies(codes: string[], nameOf: (c: string) => string, query: string): string[] {
  const q = norm(query);
  if (!q) return codes;
  const starts: string[] = [], rest: string[] = [];
  for (const c of codes) {
    const code = c.toLowerCase();
    if (code.startsWith(q)) starts.push(c);
    else if (code.includes(q) || norm(nameOf(c)).includes(q)) rest.push(c);
  }
  return [...starts, ...rest];
}
